import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NetworkPrinterService} from '../../../_services/networkPrinter.service';
import {Printer} from '../../../_models/Printer';
import {AESEncryptDecryptService} from '../../../_services/aesencrypt-decrypt.service';
import {AlertService, UserService} from '../../../_services';
import {Router} from '@angular/router';
import {NotifierService} from 'angular-notifier';
import {Category} from "../../../_models/category";
import {IDropdownSettings} from "ng-multiselect-dropdown";
import {Modifier} from "../../../_models/modifier";
import {first} from "rxjs/operators";
import {CloverApiService} from "../../../_services/cloverApi.service";


@Component({
  selector: 'app-printer-select-popup',
  templateUrl: './printer-select-popup.html',
  styleUrls: ['./printer-select-popup.component.scss']
})
export class PrinterSelectPopupComponent implements OnInit {

  description: string;
  labelName = "New Tab Name";
  message: string;
  errorMessage: string;
  selectedRole: string;
  loading = false;
  assignedTables = false;
  printers: Printer[] = [];
  button_text = 'Submit';
  selectedPrinters: Printer[] = [];
  printerLogos: Record<string, string> = {
    'Star Micronics Ltd': 'assets/star.png',
    'Brother': 'assets/star.png',
    'Epson': 'assets/star.png',
    'Xerox': 'assets/star.png',
    // add more...
  };

  configScreen = false;

  categories: Category[] = [];
  // selectedCategories: Category[] = [];
  categoryDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    // selectAllText: "Select All",
    // unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
    enableCheckAll: false
  };

  itemDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    // selectAllText: "Select All",
    // unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
    enableCheckAll: false
  };

  modifierDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    // selectAllText: "Select All",
    // unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
    enableCheckAll: false
  };

  // Default to Auto Print

  // V3 is the current default sticky-label layout the backend emits when no
  // `labelVersion` is supplied (see printerConnectionService.printStarLabel).
  // V3 MUST be the first option so the dropdown preselects it instead of
  // rendering blank when a fresh KDS session opens — pre-fix the seeded
  // default was 'v3' but the option list only contained 'v1' and 'v2', so
  // mat-select couldn't resolve the selection and showed an empty box.
  labelVersionOptions = [
    { value: 'v3', label: 'V3 – Sticky Label (default)' },
    { value: 'v2', label: 'V2 – New Style' },
    { value: 'v1', label: 'V1 – Legacy Style' },
  ];

  paperSizeOptions = [
    { value: '80mm', label: '3 1/8" roll (80mm, ~48 chars)' },
    { value: '58mm', label: '2 1/4" roll (58mm, ~32 chars)' },
  ];

  // Printer-model / ESC-POS dialect dropdown. Mirrors the same list rendered
  // on the Global Printers screen (PrinterConfigComponent.printerModelOptions)
  // so the cashier can pick the right driver for the device they are using
  // — without this the KDS path was emitting Star-only commands to Epson
  // TM-L90 / generic-thermal clones, producing leading-"a" + missing-cut
  // artefacts. 'Auto-detect' keeps the legacy behaviour: backend resolves
  // the dialect from the saved Printer document (printer.printerProfile)
  // when no profile is sent in the payload.
  readonly printerModelOptions: ReadonlyArray<{
    value: string; label: string; profile: 'star' | 'epson';
  }> = [
    { value: '',          label: 'Auto-detect (use saved profile)',                  profile: 'star'  },
    { value: 'xk200',     label: 'Xprinter / XK200L / XK-58 (generic thermal)',     profile: 'epson' },
    { value: 'munbyn',    label: 'MUNBYN',                                          profile: 'epson' },
    { value: 'rongta',    label: 'RongTa',                                          profile: 'epson' },
    { value: 'gp-80',     label: 'GP-80 / GP-58',                                   profile: 'epson' },
    { value: 'epson',     label: 'Epson TM-T88 / TM-T20 / TM-L90',                  profile: 'epson' },
    { value: 'generic_thermal', label: 'Other generic thermal (Epson dialect)',     profile: 'epson' },
    { value: 'star',      label: 'Star TSP100 / TSP143 / mC-Print',                 profile: 'star'  },
  ];

  autoPrint = {
    categories: [],
    modifiers: [],
    items: [],
    selectedPrinters: [],
    autoPrint: false,
    labelVersion: 'v3',
    paperSize: '80mm',
    filterPaid: false,
    // Empty string = auto-detect from saved printer doc. Set by
    // onPrinterModelChange when the cashier picks a specific model.
    printerModel: '' as string,
    printerProfile: 'star' as 'star' | 'epson',
  };
  items: any[] = [];
  modifiers = [];

  constructor(private dialogRef: MatDialogRef<PrinterSelectPopupComponent>, private printerService: NetworkPrinterService, private notifier: NotifierService,
              private _AESEncryptDecryptService: AESEncryptDecryptService, @Inject(MAT_DIALOG_DATA) data,
              private cloverApiService: CloverApiService) {
    this.description = data.title;
    this.message = data.message;
    this.categories = data.categories;
  }

  ngOnInit() {
    this.loadPrinters();
    this.loadCloverItems();
    this.loadModifiers();
  }

  loadPrinters(): void {
    this.printerService.getAll().subscribe(printers => {
        // console.log('Fetched Employees:', employees);
        this.printers = printers;
//                   this.cdRef.detectChanges();
      },
      error => console.error('Error loading printers:')
    );
  }

  loadModifiers(): void {
    this.cloverApiService.getAllModifiers().subscribe(modifiers => {
        this.modifiers = modifiers;
      },
      error => console.error('Error loading modifiers:')
    );
  }

  private loadCloverItems() {
    this.cloverApiService.getAllItems(1000, 1)
      .pipe(first())
      .subscribe((items: any[]) => {
        this.items = items;
      });

  }

  close() {
    this.dialogRef.close();
  }

  public showNotification(type: string, message: string): void {
    this.notifier.notify(type, message);
  }

  submit() {
    if (this.autoPrint.selectedPrinters[0] && !this.configScreen) {
      this.configScreen = true;
      return;
    }
    this.dialogRef.close(this.autoPrint);
  }

  onFilterCategorySelect(item: any) {
    this.autoPrint.categories.push(item);
    localStorage.setItem('printerCategories', JSON.stringify(this.autoPrint.categories));
  }

  onFilterCategoryDeSelect(item: any) {
    this.autoPrint.categories = this.autoPrint.categories.filter((value) => value.id !== item.id);
    localStorage.setItem('printerCategories', JSON.stringify(this.autoPrint.categories));
  }

  onFilterItemSelect(item: any) {
    this.autoPrint.items.push(item);
    localStorage.setItem('printerItems', JSON.stringify(this.autoPrint.items));
  }

  onFilterItemDeSelect(item: any) {
    this.autoPrint.items = this.autoPrint.items.filter((value) => value.id !== item.id);
    localStorage.setItem('printerItems', JSON.stringify(this.autoPrint.items));
  }
  onFilterModifierSelect(item: any) {
    this.autoPrint.modifiers.push(item);
    localStorage.setItem('printerModifiers', JSON.stringify(this.autoPrint.modifiers));
  }

  onFilterModifiersDeSelect(item: any) {
    this.autoPrint.modifiers = this.autoPrint.modifiers.filter((value) => value.id !== item.id);
    localStorage.setItem('printerModifiers', JSON.stringify(this.autoPrint.modifiers));
  }

  /**
   * Keep autoPrint.printerProfile in lockstep with the model picked in
   * the dropdown — same pattern as the Global Printers screen. Storing
   * the profile separately means the backend can resolve the ESC/POS
   * dialect without re-deriving it from the model string on every print
   * call (and a future schema change can override the heuristic without
   * losing the user's choice).
   */
  onPrinterModelChange(value: string): void {
    const opt = this.printerModelOptions.find(o => o.value === value);
    this.autoPrint.printerModel = opt ? opt.value : '';
    this.autoPrint.printerProfile = opt ? opt.profile : 'star';
  }
}
